import React, { useEffect, useState } from "react";
import { AppBar, Toolbar, Button, Box } from "@mui/material";
import { connectToWallet, getToken } from "../extensionMethods/app";
import config from "../config";
import { DAPP_ICON } from "../constants";
import ResponseModal from "./ResponseModal";

const Header = ({ isConnected, setIsConnected }) => {
  const [responseMessage, setResponseMessage] = useState("");
  const [modalShow, setModalShow] = useState(false);

  let dappToken = "";

  const checkWalletConnection = async () => {
    try {
      if (!window?.kalpwallet) {
        setResponseMessage(
          "Wallet connect request denied. Install Kalp wallet web extension to continue"
        );
        setIsConnected(false);
        setModalShow(true);
        return;
      }

      const dappToken = getToken();
      const res = await connectToWallet(
        dappToken,
        "CBDC",
        config.DAPP_URL,
        DAPP_ICON,
        config.CHANNEL_NAME,
        () => setIsConnected(false)
      );

      setIsConnected(res?.approved || false);
    } catch (err) {
      console.log("Error checking wallet connection", err);
      setIsConnected(false);
    }
  };

  useEffect(() => {
    checkWalletConnection(); // Run on mount
  }, []);

  const connectToWalletFromDapp = async () => {
    try {
      console.log("here");
      console.log(window?.kalpwallet);
      if (!window?.kalpwallet) {
        setResponseMessage(
          "Wallet connect request denied. Install Kalp wallet web extension to continue"
        );
        console.log("Web extension not installed");
        setModalShow(true);

        return;
      }
      if (dappToken === "") {
        dappToken = getToken();
      }
      localStorage.setItem("opensea_dappToken", dappToken);
      const res = await connectToWallet(
        dappToken,
        "CBDC",
        config.DAPP_URL,
        DAPP_ICON,
        config.CHANNEL_NAME,
        () => setIsConnected(false)
      );

      console.log("result", res);

      setIsConnected(res?.approved);
      if (!res?.approved && res?.message === "Wallet not found") {
        setResponseMessage(
          "Wallet connect request denied. Please sign in to Kalp wallet web extension to continue"
        );
        setModalShow(true);

        console.log("Please connect your wallet to extension");
      } // Update the connected state to true
    } catch (e) {
      console.log(`Error: ${e}`);
      setIsConnected(false); // Update the connected state to false on error
    }
  };

  return (
    <>
      {modalShow && (
        <ResponseModal
          show={modalShow}
          onHide={() => setModalShow(false)}
          message={responseMessage}
        />
      )}
      <AppBar
        position="fixed"
        color="transparent"
        elevation={1}
        sx={{
          zIndex: 1201,
          backgroundColor: "#fff",
          padding: "0 40px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Toolbar
          style={{
            display: "flex",
            justifyContent: "flex-end", // Align the button to the right
            alignItems: "center",
          }}
        >
          {/* Connected/Connect Button */}
          <Button
            variant="contained"
            sx={{
              backgroundColor: isConnected ? "#0055ff" : "#0033cc", // Change color based on connection status
              color: "#fff",
              textTransform: "none",
              fontSize: "14px",
              padding: "8px 20px",
              borderRadius: "10px",
              fontWeight: "bold",
            }}
            onClick={connectToWalletFromDapp} // Call the connect function on click
          >
            {isConnected ? "Connected" : "Connect to Wallet"}{" "}
            {/* Conditional text */}
          </Button>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
